import { Config } from './config'

export const config = new Config()
